import type { FixedDynamicLineItem, UsageDynamicLineItem } from '@vy/dynamic-invoice-builder';
import { PRICING_MODELS } from '@vy/types';

type PriceConfigurationWithPercentage = {
  percentage?: number;
  percentageToDeduct?: number;
};

export const getLineItemPercentage = (
  lineItem: FixedDynamicLineItem | UsageDynamicLineItem,
): number | null => {
  const pricingModel = lineItem.pricingModel;

  if (pricingModel === PRICING_MODELS.Commission) {
    const config = (lineItem as FixedDynamicLineItem).priceConfiguration as PriceConfigurationWithPercentage;
    return config?.percentage ?? null;
  }

  if (pricingModel === PRICING_MODELS.PercentageDeduction) {
    const config = (lineItem as FixedDynamicLineItem).priceConfiguration as PriceConfigurationWithPercentage;
    return config?.percentageToDeduct ?? null;
  }

  return null;
};
